<template>
    <div class="rate" :key="item.name">
        <div class="rate__info-container">
            <p class="rate__name">{{ item.name }}</p>
            <p class="rate__times">{{ item.times }}</p>
            <p v-if="item.supDescr" class="rate__sup-descr">{{ item.supDescr }}</p>
            <p v-if="item.list" class="rate__list-name">{{ item.list.name }}</p>
            <ul v-if="item.list" class="rate__list">
                <li v-for="listItem in item.list.items" :key="listItem">
                    <p class="rate__list-item">{{ listItem }}</p>
                </li>
            </ul>
            <p class="rate__descr" v-for="item in item.descr">
                {{ item }}
            </p>
        </div>
        <div class="rate__price-container">
            <p class="rate__price">{{ item.price.price }}</p>
            <p class="rate__price-again">{{ item.price.again }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RateItemVue',
    props: {
        item: {}
    }
}
</script>
<style lang="scss" scoped>
.rate {
    width: 328px;
    padding: 24px 20px 22px;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid #DAD5D2;
    border-radius: 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 21px;
    @media (max-width: 1439px) {
        width: auto;
        height: 100%;
    }
    @media (max-width: 479px) {
        padding: 24px 10px 25px;
    }

    &__price-container {
        text-align: center;
        padding-top: 14px;
        border-top: 1px solid #DAD5D2;
    }

    &__price {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 26px;
        line-height: 120%;
        color: #534340;
    }

    &__price-again {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        color: rgba(83, 67, 64, 0.5);
    }

    &__name {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 1;
        text-align: center;
        letter-spacing: 0.025em;
        color: #724821;
        @media (max-width: 479px) {
            font-size: 26px;
        }
    }

    &__times {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 1;
        text-align: center;
        letter-spacing: 0.025em;
        margin-top: 10px;
        color: rgba(83, 67, 64, 0.5);
        margin-bottom: 25px;
        @media (max-width: 479px) {
            font-size: 14px;
        }
    }

    &__sup-descr, &__descr, &__list-name {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: #534340;
        margin-top: 16px;

        &:first-child {
            margin-top: 0;
        }

        @media (max-width: 479px) {
            font-size: 14px;
            margin-top: 8px;
        }
    }

    &__list {
        list-style: none;
        margin-top: 16px;
    }

    &__list-item {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
        color: rgba(83, 67, 64, 0.6);
        display: flex;
        gap: 8px;
        margin-top: 8px;

        &:before {
            content: '';
            display: block;
            width: 8px;
            min-width: 8px;
            margin-top: 5px;
            height: 8px;
            border-radius: 100%;
            box-sizing: border-box;
            border: 1px solid rgba(83, 67, 64, 0.6);
        }

        @media (max-width: 479px) {
            font-size: 14px;
        }
    }
}
</style>
